import { FC, Fragment, useEffect, useRef, useState } from "react";
import Button from "./bootstrap/Button"
import Dropdown, { DropdownToggle, DropdownMenu, DropdownItem } from "./bootstrap/Dropdown"
import Spinner from "./bootstrap/Spinner";
import { ActionStatus, Status } from "../type/actionStatus-type";
import { handleConfirmationAlert } from "../utils/ConfirmationAlert";
import FormGroup from "./bootstrap/forms/FormGroup";
import './StatusOperationDropdown.css';
import { OperationService } from "../services/operations/operationService";
import useHandleErrors from "../hooks/useHandleErrors";

interface StatusOperationDropdownProps {
    itemId: string;
    statusName: any;
    statusColor: any;
    statusId: any;
    entity: string;
    additionalInfo?: string;
    onChange?: () => void;
    disabled?: boolean;
    statuses?: ActionStatus[];
}

const StatusOperationDropdown: FC<StatusOperationDropdownProps> = ({ itemId, statusName, statusColor, statusId, onChange, disabled = false, entity, additionalInfo, statuses }) => {

    const [currentStatus, setCurrentStatus] = useState<any>({ id: statusId, name: statusName, color: statusColor });
    const [nameStatus, setNameStatus] = useState<string>(statusName);
    const [color, setColor] = useState<string>(statusColor);
    const commentRef = useRef<HTMLTextAreaElement | null>(null);
    const [actionStatusList, setActionStatusList] = useState<Status[]>(statuses ? statuses : []);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { handleErrors } = useHandleErrors();

    useEffect(() => {
        setActionStatusList(statuses ? statuses : []);
    }, [statuses]);


    const _toggleState = (newStatus: string) => {
        handleConfirmationAlert({
            title: '¿Estás segur@ de que deseas cambiar de estado?',
            html: (
                <>
                    <p>Se cambiará el estado de contrato</p>
                    <FormGroup label="Comentario:" requiredInputLabel>
                        <textarea ref={commentRef} className="form-control" rows={5}></textarea>
                    </FormGroup>
                </>
            ),
            icon: 'warning',
            onConfirm: () => {
                let commentValue = commentRef.current?.value || null;
                
                setIsLoading(true);

                setTimeout(() => {
                    _toggleStatus(newStatus, commentValue);
                }, 200);

            }
        });
    }

    const _toggleStatus = async (
        status: string,
        commentValue: string | null
    ) => {
        let response = await (
            await new OperationService().changeActionStatus(
                itemId,
                status,
                commentValue
            )
        ).getResponseData();

        if (response.success) {
            if (entity === "operation") {
                setCurrentStatus(response.data.currentActionStatus);
            }
            if (entity === "contract") {
                setCurrentStatus(response.data.currentContractStatus);
            }
            if (entity === "commission") {
                setCurrentStatus(response.data.currentCommissionStatus);
            }
            onChange && onChange();
        } else {
            handleErrors(response);
        }
        setIsLoading(false);
    };


    useEffect(() => {
        if (currentStatus) {
            setColor(currentStatus?.color ? currentStatus.color : 'whitesmoke');
            setNameStatus(currentStatus.name);
        }
    }, [currentStatus]);


    return (
        <Dropdown className={'status-operation-dropdown'} key={itemId + "-" + entity + "-dropdownItem"}>
            <DropdownToggle hasIcon={false}>
                <Button isLink isDisable={disabled} className='text-nowrap fs-8  p-2' style={{ backgroundColor: color }}>
                    {isLoading ? <Spinner isSmall /> : <Fragment><span className='text-white fw-bold fs-8 ' style={{ color: '#3e3e3e' }}> {nameStatus}  </span></Fragment>}
                    {additionalInfo ? <Fragment> <br /> <small className='text-white fw-bold fs-8 ' style={{ color: '#3e3e3e' }}> {additionalInfo} </small> </Fragment> : null}
                </Button>

            </DropdownToggle>
            <DropdownMenu className="max-h-250 overflow-auto">
                {actionStatusList?.filter((actionStatus: Status) => actionStatus.id !== currentStatus?.id)?.map((actionStatus: Status) => {
                    return (
                        <DropdownItem key={itemId + "-" + actionStatus.id + "-dropdownItem"} className={'mt-2'} >
                            <Button
                                className="text-nowrap fs-8  fw-semibold text-center"
                                style={{ backgroundColor: actionStatus.color ? actionStatus.color : 'white', color: "white" }}
                                isLink
                                onClick={() => _toggleState(actionStatus.id)}>
                                <span className="text-center w-100 fs-8 " style={{ color: 'white' }}>
                                    {actionStatus.name}
                                </span>
                            </Button>
                        </DropdownItem>
                    )
                }
                )}
                {/* 
                    <DropdownItem >
                                <Button isLink onClick={() => {navigate(`/operations-action-status`);}} icon='Add' className='text-primary text-center'> Añadir </Button>
                    </DropdownItem>
                */}
            </DropdownMenu>
        </Dropdown>
    )
}

export default StatusOperationDropdown;